export function disableButtonForSeconds(btn, seconds = 10) {
  if (!btn) return

  const originalText = btn.innerHTML
  btn.disabled = true
  let remaining = seconds
  btn.innerHTML = `Loading... (${remaining})`

  const interval = setInterval(() => {
    remaining -= 1
    btn.innerHTML = `Loading... (${remaining})`
    if (remaining <= 0) {
      clearInterval(interval)
      btn.innerHTML = originalText
      btn.disabled = false
    }
  }, seconds*100)
}
